import React from 'react'
import MultiFilter from '../../../components/UIComponents/MultiFilter.js'
import { BoldText, MultiPadding, SelectAllFlex } from '../style'
import TableWholeData from './TableData/index'
import TableFilter from './TableFilter/index'
import Button from 'components/Button'

const TableData = ({
  BreadShowStudent,
  folderSearch,
  setFolderSearch,
  tableData,
  pageSize,
  handlePageChange,
  tableloader,
  searchBy,
  handleSorting,
  FilterMenu,
  isMenuOpen,
  setIsMenuOpen,
  onOpenChange,
  filterdata,
  handleMultiFilter,
  handleSearch,
  handleFolderSearch,
  getPreviewData,
  getPlacementHistoryList,
  getStudentPlacedList,
  getJobRolePreview,
  placeholder,
  jobCategoryList,
  selectedStudents,
  setSelectedStudents,
  isAllSelect,
  setIsAllSelect,
  enabled,
  setEnabled,
  studentCount,
  handleClearAll,
  handleSelectAll,
  studentListId
}) => {
  return (
    <div>
          {BreadShowStudent === 'true' && studentCount > 10 && enabled && (
            <div style={{marginBottom:4}}>
       <SelectAllFlex>
        <div style={{ fontSize: '13px', padding: '0px 20px' }}>
          {`Selected `}
          <span style={{ fontWeight: 800 }}>
            {`${isAllSelect ? studentCount : studentListId?.length} ${
              studentListId?.length > 1 ? 'students' : 'student'
            }`}
          </span>
          {isAllSelect ? ` from all pages` : ` from this page.`}
        </div>
    
        <Button.Primary
          onClick={() => (isAllSelect ? handleClearAll() : handleSelectAll())}
          text={
            isAllSelect ? (
              'Clear Selection'
            ) : (
              <>
                {`Select all `}
                <span style={{ fontWeight: 800 }}>
                  {`${studentCount} ${
                    studentCount > 1 ? 'students' : 'student'
                    }`}
                </span>
                {` from all pages.`}
              </>
            )
          }
          fontsize={'0.8rem'}
        />
      </SelectAllFlex>
        </div>
          )}
      <TableFilter
        BreadShowStudent={BreadShowStudent}
        placeholder={placeholder}
        folderSearch={folderSearch}
        setFolderSearch={setFolderSearch}
        searchBy={searchBy}
        currentCount={pageSize * 10 + tableData?.data?.result?.length || 0}
        totalCount={tableData?.data?.count || 0}
        FilterMenu={FilterMenu}
        isMenuOpen={isMenuOpen}
        setIsMenuOpen={setIsMenuOpen}
        onOpenChange={onOpenChange}
        filterdata={filterdata}
        handleFolderSearch={handleFolderSearch}
        handleSearch={handleSearch}
      />
      {BreadShowStudent && filterdata.length !== 0 && (
        <MultiPadding>
          <BoldText>Filter</BoldText>
          <MultiFilter
            jobRoleForm={
              filterdata.length !== 0 &&
              filterdata?.map(item => {
                return item.nameValue
              })
            }
            option={false}
            handleChange={handleMultiFilter}
          />
        </MultiPadding>
      )}
      {BreadShowStudent === 'true' && (
        <> 
        <TableWholeData
          tableData={tableData?.length !== 0 && tableData?.data?.result}
          totalPages={(tableData?.length !== 0 && tableData?.data?.count) || 0}
          handlePageChange={handlePageChange}
          pageSize={pageSize}
          getdata={tableData}
          tableloader={tableloader}
          handleSorting={handleSorting}
          getPreviewData={getPreviewData}
          getJobRolePreview={getJobRolePreview}
          getStudentPlacedList={getStudentPlacedList}
          getPlacementHistoryList={getPlacementHistoryList}
          jobCategoryList={jobCategoryList}
          selectedStudents={selectedStudents}
          setSelectedStudents={setSelectedStudents}
          isAllSelect={isAllSelect}
          setIsAllSelect ={setIsAllSelect}
          setEnabled={setEnabled}
        />
        </>
      )}
    </div>
  )
}

export default TableData
